import { dayKey } from '$features/forecast';
import {
  MAX_DURATION_MIN,
  MIN_DURATION_MIN,
  QUALITY_MAX,
  QUALITY_MIN,
  type SleepInput,
  type SleepValidation
} from './types';

export const CIRCADIAN_ANCHOR_HOUR = 18;

export function circadianDate(iso: string): string {
  const d = new Date(iso);
  const hours = d.getHours();
  if (hours < CIRCADIAN_ANCHOR_HOUR) {
    const shifted = new Date(d);
    shifted.setDate(shifted.getDate() - 1);
    return dayKey(shifted);
  }
  return dayKey(d);
}

export function validateSleep(input: SleepInput): SleepValidation {
  const bed = new Date(input.bedtime).getTime();
  const wake = new Date(input.wakeTime).getTime();
  const durationMs = wake - bed;
  const durationMinutes = Math.round(durationMs / 60000);
  const cd = circadianDate(input.bedtime);

  if (!Number.isFinite(durationMs) || durationMs <= 0) {
    return { ok: false, error: 'invalid_order', durationMinutes: 0, circadianDate: cd };
  }
  if (durationMinutes > MAX_DURATION_MIN) {
    return { ok: false, error: 'too_long', durationMinutes, circadianDate: cd };
  }
  if (durationMinutes < MIN_DURATION_MIN) {
    return { ok: false, error: 'too_short', durationMinutes, circadianDate: cd };
  }
  return { ok: true, error: null, durationMinutes, circadianDate: cd };
}

export function clampQuality(q: number): number {
  if (!Number.isFinite(q)) return QUALITY_MIN;
  return Math.max(QUALITY_MIN, Math.min(QUALITY_MAX, Math.round(q)));
}